import Api from "./Api";
import { API_VERSION } from "@/config/index";
export default {
  GetCityList(payload) {
    return Api().get(`${API_VERSION}/webapp/citylist`);
  },
  AdvertiseWithUs(payload) {
    return Api().post(`${API_VERSION}/webapp/advertisewithus`, payload);
  },
  GetPopups(payload) {
    return Api().get(`${API_VERSION}/webapp/popups`, { params: payload });
  },
  GetBanners(payload) {
    return Api().get(`${API_VERSION}/webapp/banners`, payload);
  },
  GetTermsConditions(payload) {
    return Api().get(`${API_VERSION}/webapp/terms-conditions`, payload);
  },
  GetConvenienceFee(payload) {
    return Api().get(`${API_VERSION}/webapp/convenience-fee`, { params: payload });
  },
  SendTicketAsGift(payload) {
    return Api().post(`${API_VERSION}/webapp/send-ticket-as-gift`, payload);
  },
  UploadImage(payload) {
    const configHeaders = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };
    return new Promise((resolve, reject) => {
      Api()
        .post(`${API_VERSION}/webapp/upload/image`, payload, configHeaders)
        .then(res => resolve(res))
        .catch(error => reject(error));
    });
  },
  GetPageData(payload) {
    const { page_code } = payload;
    return Api().get(`${API_VERSION}/webapp/pages/${page_code}`);
  },
  GetPageImages(payload) {
    const { page_code } = payload;
    return Api().get(`${API_VERSION}/webapp/images/${page_code}`);
  }
};



// WEBPACK FOOTER //
// ./src/apiServices/MasterService.js